import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useAdminService } from '~/services';
import {
    EntityTypeType,
    MarketRestriction,
    RoleSelection,
    UserRoleType,
    useRoleOptions,
} from '~/components/Admin';
import { UpdateUserRoleDataType } from '~/services/AdminService/useUpdateUserRole';

export interface MarketRestrictionType {
    value: PatientMarketType;
    label: string;
}
interface EditRoleProps {
    entityType: EntityTypeType;
    role: UserRoleType;
    setIsEditing: (x: boolean) => void;
}
export function EditRole({ entityType, role, setIsEditing }: EditRoleProps) {
    const { updateUserRole } = useAdminService();
    const { roleOptions } = useRoleOptions();
    const [loading, setLoading] = React.useState(false);
    const [editedRole, setEditedRole] = React.useState(
        roleOptions.find((x) => x.value === role[`${entityType}_roles`]![0])
    );
    const [marketRestriction, setMarketRestriction] = React.useState<MarketRestrictionType[]>(
        role?.markets?.map((x) => ({
            value: x,
            label: x.name,
        })) || []
    );

    function cancelEditing() {
        setIsEditing(false);
        setEditedRole(roleOptions.find((x) => x.value === role[`${entityType}_roles`]![0]));
    }

    async function edit() {
        try {
            setLoading(true);
            const data: UpdateUserRoleDataType = { [`${entityType}_roles`]: [editedRole?.value] };
            if (marketRestriction?.length > 0) {
                data.markets = marketRestriction.map((x) => ({ id: x.value.id }));
            } else if (entityType === 'organization') {
                data.markets = [];
            }
            await updateUserRole(role.id, data, entityType);
            setLoading(false);
            setIsEditing(false);
        } catch (e) {
            setLoading(false);
        }
    }

    return (
        <>
            <RoleSelection
                entityType={entityType}
                entityName={role.id}
                setRole={setEditedRole}
                value={editedRole}
            />
            <MarketRestriction
                entityType={entityType}
                entityName={role.id}
                setValue={setMarketRestriction}
                value={marketRestriction}
            />
            <div className="text-end mt-2">
                <button type="button" className="btn btn-secondary" onClick={cancelEditing}>
                    Cancel
                </button>
                <button
                    type="button"
                    className="btn btn-primary ms-2"
                    onClick={edit}
                    disabled={loading}
                >
                    Submit
                    {loading && (
                        <Spinner
                            animation="border"
                            variant="light"
                            size="sm"
                            role="status"
                            className="ms-1"
                        />
                    )}
                </button>
            </div>
        </>
    );
}
